import * as microsoftTeams from '@microsoft/teams-js';

export const appIsInTeams = window.name === 'embedded-page-container' || window.name === 'extension-tab-frame';

// Lazy singleton: the promise is created on first call, not at module load.
// This ensures the Teams SDK isn't initialized too early (before the host is ready).
let _teamsContextPromise: Promise<microsoftTeams.app.Context | null> | null = null;

export const getTeamsContext = (): Promise<microsoftTeams.app.Context | null> => {
  if (!_teamsContextPromise) {
    _teamsContextPromise = microsoftTeams.app.initialize()
      .then(() => {
        (window as any).__isInTeams = true;

        // Respond to host suspend/terminate signals so Outlook doesn't kill the app after 30s
        microsoftTeams.app.lifecycle.registerBeforeSuspendOrTerminateHandler(() => {});
        microsoftTeams.app.lifecycle.registerOnResumeHandler(() => {
          microsoftTeams.app.notifySuccess();
          if (typeof window['_onReturnToForeground'] === 'function') {
            window['_onReturnToForeground']();
          }
        });

        return microsoftTeams.app.getContext();
      })
      .then((context) => {
        (window as any).__teamsClientType = context.app.host.clientType;
        (window as any).__teamsHostName = context.app.host.name;
        return context;
      })
      .catch(() => null);
  }

  return _teamsContextPromise;
};
